import BankIcon from "@fla/components/src/assets/svgs/bank_card.svg";
import { InitialDetails } from "@fla/components/src/interfaces";

import { banks, debtTypeOptions } from "../../../definitions";

export function useNames({ initialDetails }: { initialDetails: InitialDetails }) {
  const { spouse, user } = initialDetails ?? {};

  // this used to determine primary care giver.
  const spouseFirstName = spouse?.first_name;
  const userFirstName = user?.first_name;

  const getName = (val: string = "") => {
    if (val && ["spouse1", "user"].includes(val)) return user?.first_name;
    else if (val && ["spouse2", "spouse"].includes(val)) return spouse?.first_name;
    else if (val && ["jointly_owned", "joint"].includes(val)) return "Joint";
    else return val;
  };

  const getFullName = (val: string) => {
    if (["spouse1", "user"].includes(val)) return `${user?.first_name} ${user?.last_name}`;
    else if (["spouse2", "spouse"].includes(val)) return `${spouse?.first_name} ${spouse?.last_name}`;
    else if (["jointly_owned", "joint"].includes(val)) return "Joint";
    else return val;
  };

  const getAlternateName = (val: string = "") => {
    if (val && ["spouse1", "user"].includes(val)) return spouse?.first_name;
    else if (val && ["spouse2", "spouse"].includes(val)) return user?.first_name;
    else return val;
  };

  const getAlternateFullName = (val: string = "") => {
    if (["spouse2", "spouse"].includes(val)) return `${user?.first_name} ${user?.last_name}`;
    else if (["spouse1", "user"].includes(val)) return `${spouse?.first_name} ${spouse?.last_name}`;
    else return val;
  };

  const getBankDetails = (val: string) => {
    return (
      banks.find(data => data.value === val) || {
        label: val,
        value: val,
        img: BankIcon
      }
    );
  };

  const getBankType = (val: string) => {
    return debtTypeOptions.find(d => d.value === val)?.label;
  };

  return {
    spouseFirstName,
    userFirstName,
    getName,
    getFullName,
    getAlternateName,
    getAlternateFullName,
    getBankDetails,
    getBankType
  };
}
